document.addEventListener("DOMContentLoaded", function () {
  const finishWrapper = document.getElementById("variant-finish-wrapper");

  if (!finishWrapper) {
       return;
  }

  function updateFinishDescription(variantId) {
    const allBlocks = finishWrapper.querySelectorAll(".variant-finish-content");
    allBlocks.forEach((block) => {
      block.style.display = block.dataset.variantId === variantId ? "block" : "none";
    });
  }

  if (!window.__finishInstructionsListenerAdded) {
    document.addEventListener("variant:updated", function (e) {
      const newVariantId = e.detail?.variantId || window.CurrentVariant?.id;
      if (newVariantId) {
        updateFinishDescription(newVariantId);       
      }
    });
    window.__finishInstructionsListenerAdded = true;
  }

  if (window.CurrentVariant?.id) {
    updateFinishDescription(window.CurrentVariant.id);   
  }
});
